// Helpers for the agreement rich-text body.
//
// Trust model: ONLY a body whose `bodyFormat === 'html'` is treated as HTML —
// those rows were sanitized server-side on write. Everything else (legacy rows,
// missing/unknown format) is treated as untrusted PLAIN TEXT and escaped before
// rendering, so old data can never inject markup into dangerouslySetInnerHTML.

export function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Escaped plain text with newlines turned into <br>. */
export function plainToHtml(text) {
  return escapeHtml(text).replace(/\r?\n/g, '<br>');
}

/**
 * HTML safe to drop into dangerouslySetInnerHTML. Also used to seed the editor
 * when opening an existing row. HTML format passes through (server-sanitized);
 * anything else is escaped legacy plain text.
 */
export function bodyToHtml(body, bodyFormat) {
  if (bodyFormat === 'html') return body || '';
  return plainToHtml(body || '');
}

/** Visible text of an HTML string (tags removed) — for validation/previews. */
export function htmlToText(html) {
  const s = html || '';
  if (typeof document !== 'undefined') {
    const tmp = document.createElement('div');
    tmp.innerHTML = s;
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  }
  return s.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

/** Plain-text preview for a stored row, honouring its format. */
export function previewText(body, bodyFormat) {
  if (bodyFormat !== 'html') return (body || '').replace(/\s+/g, ' ').trim();
  return htmlToText(body);
}
